import {
  AccountCircle,
  PasswordRounded,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import {
  Grid,
  Typography,
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  FormControl,
  Fade,
} from "@mui/material";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import ButtonLoader from "../../Components/ButtonLoader";
import { Link } from "react-router-dom";
import authService from "services/authService.ts";
import sessionStorage from "Utils/sessionStorage";
import { useDispatch } from "react-redux";
import { fetchEntities } from "store/actions/entityActions.ts";
import { setUser } from "store/actions/userActions.ts";
import { setIsLoggedIn } from "store/actions/authActions.ts";
const Login = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const handleSuccessfulLogin = (result) => {
    sessionStorage.setUserSessionStorage(result.data?.user?.dataValues ?? null);
    sessionStorage.setAuthStorage(result.data.authToken.dataValues ?? null);
    dispatch(setUser(result.data?.user?.dataValues));
    dispatch(setIsLoggedIn(true));
    dispatch(fetchEntities(result?.data?.user?.dataValues?.id));
    history.push("/dashboard");
  };
  const handleLogin = async () => {
    try {
      setError("");
      setLoading(true);
      const result = await authService.login(username, password);
      if (result.status === 200) {
        handleSuccessfulLogin(result);
      } else {
        throw new Error("Invalid username or password");
      }
    } catch (error) {
      setError(error.message);
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid
      container
      columns={16}
      sx={{ height: "92vh" }}
      justifyContent="center"
      flexDirecton="column"
      alignItems="center"
      display="flex"
    >
<Fade in>
        <Box>
          <Grid item sx={{ mb: 6 }}>
            <Typography
              fontWeight={700}
              sx={{ fontSize: { xs: "48px", sm: "56px" }, lineHeight: 1.1 }}
              textAlign={{ xs: "center" }}
            >
              Welcome Back.
            </Typography>
          </Grid>
          <Box component="form">
            <Grid item xs={16}>
              <TextField
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle sx={{ fontSize: "2rem" }} />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                placeholder="Username"
                // label="Email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                sx={{ textUnderlineOffset: "20px", pb: 1, fontSize: "24px" }}
              />
            </Grid>
            <Grid xs={16} item sx={{ mt: 6, borderRadius: 2 }}>
              <TextField
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PasswordRounded sx={{ fontSize: "2rem" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <VisibilityOutlined sx={{ fontSize: "2rem" }} />
                        ) : (
                          <VisibilityOffOutlined sx={{ fontSize: "2rem" }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
                placeholder="Password"
                type={showPassword ? "" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Grid>
            <Grid
              container
              xs={16}
              display="flex"
              justifyContent="space-between"
            ></Grid>
            <Grid
              xs={16}
              marginTop={6}
              item
              justifyContent="center"
              display="flex"
            >
              <Button
                disabled={loading || !username || !password}
                onClick={handleLogin}
                type="submit"
                sx={{ pl: 8, pr: 8, textTransform: "none" }}
                variant="contained"
                fullWidth
              >
                <ButtonLoader text={"Login"} loading={loading} size={20} />
              </Button>
            </Grid>
          </Box>
          <Grid
            marginTop={6}
            xs={16}
            item
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Typography>
              By continuing, you agree to the terms of use and
              <Link
                style={{ textDecoration: "none", color: "gray" }}
                to="/privacy"
              >
                {" "}
                Privacy Policy
              </Link>
            </Typography>
          </Grid>
        </Box>
      </Fade>
    </Grid>
  );
};

export default Login;
